<template>
  <v-app id="inspire" v-bind:style="appStyle">
    <!-- <v-app id="inspire"> -->
    <!-- <v-app-bar app dark> -->
    <v-app-bar
      app
      dark
      v-bind:style="$vuetify.breakpoint.xs ? 'height:55px' : ''"
    >
      <v-app-bar-nav-icon @click="drawer = true" class="d-flex d-sm-none" />
      <v-toolbar-title class="pl-1" style="font-size:30px">
        {{ topLabel }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        v-if="!status2.loggedIn && isCanLogin"
        icon
        @click="showLoginDialog"
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn v-if="status2.loggedIn" icon @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>

      <template v-slot:extension>
        <!-- <v-tabs v-model="tab" align-with-title class="mynav d-flex"> -->
        <v-tabs v-model="tab" align-with-title class="mynav d-none d-sm-flex">
          <v-tab
            v-for="(item, idx) in navHeaders"
            :key="'mynav_' + idx"
            @click="changePage(item, idx)"
            style="font-size: 26px;"
          >
            <strong>{{ item.text }}</strong>
            <!-- <v-badge
              v-if="item.badge && carts.length > 0"
              color="amber"
              transition="slide-x-transition"
              :content="carts.length"
            /> -->
          </v-tab>
        </v-tabs>
      </template>
      <!--  -->
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary dark>
      <v-list>
        <v-list-item-group>
          <v-list-item
            v-for="(item, idx) in navHeaders"
            :key="'myvli_' + idx"
            @click="changePage(item, idx)"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              <strong>{{ item.text }}</strong>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- <v-content> -->
    <v-content v-bind:style="$vuetify.breakpoint.xs ? 'padding-top:48px' : ''">
      <LoginCentered v-if="isCanLogin" :dialogLogin="dialogLogin" />
      <ErrorDialog v-if="errorMessage !== ''" />

      <v-container>
        <router-view @changePage="changePage" @setTab="setTab" />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState, mapMutations } from 'vuex'
import LoginCentered from '../components/forwardComponent/Login.centered.vue'
import ErrorDialog from '../components/forwardComponent/errorDialog.vue'
export default {
  data: () => ({
    topLabel: '甘苦郎__報價系統',
    footerCopy: '2022',
    //
    navHeaders: [],
    drawer: null,
    tab: 0,
    // Login
    isCanLogin: false,
    dialogLogin: false,
    //
    nothing: undefined
  }),
  components: {
    LoginCentered,
    ErrorDialog
  },
  computed: {
    ...mapState('account', ['status2']),
    ...mapState('forward', ['appStyle', 'errorMessage', 'carts'])
  },
  methods: {
    ...mapActions('account', ['logout2']),
    ...mapActions('forward', ['getFeature', 'getHome']),
    //
    ...mapMutations('forward', ['setBackgroundImage', 'clearCarts']),
    changePage(item, tabIdx) {
      if (this.tab === tabIdx) return
      this.tab = tabIdx
      sessionStorage.setItem('tab', tabIdx)

      const path = item.path
      if (!path) return
      if (window.location.pathname === `/${path}`) return
      this.$router.push({ name: path })
    },
    setNavHeaders() {
      switch (window.location.pathname) {
        case '/page1':
        case '/page2':
        case '/page3':
          this.navHeaders = [
            { text: '首頁', path: 'page1', icon: 'mdi-home' },
            { text: '產品時價', path: 'page2', icon: 'mdi-chart-bar' },
            // eslint-disable-next-line prettier/prettier
            { text: '報價單', path: 'page3', icon: 'mdi-chart-timeline', badge: true }
          ]
          break
        case '/memberp1':
        case '/memberp2':
        case '/memberp3':
          this.navHeaders = [
            { text: '首頁', path: 'memberp1', icon: 'mdi-home' },
            { text: '產品時價', path: 'memberp2', icon: 'mdi-chart-bar' },
            // eslint-disable-next-line prettier/prettier
            { text: '報價單', path: 'memberp3', icon: 'mdi-chart-timeline', badge: true }
          ]
          if (!this.status2.loggedIn) this.isCanLogin = true
          break
      }
    },
    setTab() {
      let tabIdx = 0
      switch (window.location.pathname) {
        case '/page2':
        case '/memberp2':
          tabIdx = 1
          break
        case '/page3':
        case '/memberp3':
          tabIdx = 2
          break
      }
      this.tab = tabIdx
      sessionStorage.setItem('tab', tabIdx)
    },
    checkLogin() {
      if (this.status2.loggedIn) return
      let path = ''
      switch (window.location.pathname) {
        case '/memberp2':
        case '/memberp3':
          path = 'memberp1'
          break
      }
      if (!path) return
      this.tab = 0
      sessionStorage.setItem('tab', 0)
      this.$router.push({ name: path })
    },
    // Dialog Contact
    logout() {
      if (!confirm('確定登出嗎?')) return
      this.clearCarts()
      this.logout2()
      this.changePage(this.navHeaders[0])
      this.isCanLogin = true
    },
    showLoginDialog() {
      this.dialogLogin = !this.dialogLogin
      // this.dialogContact = item
    }
  },
  mounted() {
    const meta = document.getElementsByTagName('meta')['viewport']
    const cw = document.documentElement.clientWidth
    if (cw > 640) {
      meta.setAttribute('content', 'width=960')
    } else {
      meta.setAttribute('content', `width=430 initial-scale=1.0`)
    }
  },
  created() {
    this.getFeature()

    this.setNavHeaders()

    // this.setTab()

    this.checkLogin()

    document.title = this.topLabel

    // document.body.style.backgroundImage =
    //   process.env.NODE_ENV === 'development'
    //     ? `url(http://${window.location.hostname}/p221001/public/images/background_image.jpg`
    //     : `url(images/background_image.jpg`
    document.body.style['background-repeat'] = 'repeat'
    //
    // this.setBackgroundImage()
    //
    this.$nextTick(() => {
      this.tab = sessionStorage.getItem('tab') * 1
    })
  }
}
</script>

<style>
/* html,
body {
  min-width: 700px !important;
} */

#inspire {
  /* margin-bottom: 300px !important; */
  /* padding-bottom: 300px !important; */
  /* height: 2000px; */
  /* min-width: 500px !important; */
  background-color: rgba(37, 37, 37, 0) !important;
}

.v-app-bar {
  background-color: rgba(37, 37, 37, 0.8) !important;
}
.mynav .v-tabs-bar {
  background-color: rgba(37, 37, 37, 0) !important;
}
</style>
